<template>
    <v-container fluid>
        <v-row>
            <v-col 
                style="display: flex; align-content: center; align-items: center;"
                cols="4"
                lg="6"
                md="6"
                sm="4"
            >
                <h3>Dashboard</h3>
            </v-col>
        </v-row>

        <v-row>
            <v-col 
                v-if="userLoggedGetters.profile.constructionPreDig != 0"
                cols="12"
                lg="4"
                md="6"
                sm="12"
            >
                <v-card @click="goToPipelinePreDig" class="preDig_alpha">
                    <v-card-title class="text-h6 preDig d-flex justify-space-between">
                        
                        <div>
                            <v-icon left class="pipelineIconTitle">mdi mdi-account-hard-hat-outline</v-icon>
                            <label class="pipelineLabelTitle">Pre-Dig</label>
                        </div>

                        <div style="text-align: right;">
                            <label class="labelHoldResumeValue">{{ totalPreDig }}</label>
                            <label class="labelHoldResume">Open</label>
                            <label class="pipelineLabelTitle"> | </label>
                            <!-- <br /> -->
                            <label class="labelHoldResumeValue">0</label>
                            <label class="labelHoldResume">On Hold</label>
                        </div>

                    </v-card-title> 
                    <v-card-text 
                        class="pipelineDetails"
                    >
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdIncoming }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_PREDIG_INCOMING_PROJECTS.description }}</label>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdPreSite }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_PREDIG_PRESITE.description }}</label>
                                <br v-if="showWorkOrderPreSite" />
                                <table 
                                    v-if="showWorkOrderPreSite"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderPreSite" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdLocates }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_PREDIG_LOCALES.description }}</label>
                                <br v-if="showWorkOrderLocates" />
                                <table 
                                    v-if="showWorkOrderLocates"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderLocates" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdPreSiteResponsabilities }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_PREDIG_PRESITE_RESP.description }}</label>
                                <br v-if="showWorkOrderPreSiteResp" />
                                <table 
                                    v-if="showWorkOrderPreSiteResp"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderPreSiteResp" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdRebar }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_PREDIG_REBAR.description }}</label>
                                <br v-if="showWorkOrderRebar" />
                                <table 
                                    v-if="showWorkOrderRebar"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderRebar" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValueBlank">-</label>
                            </v-col>
                            <v-col 
                                cols="10"
                            >
                                <label class="pipelineLabelValueBlank">-</label>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col 
                v-if="userLoggedGetters.profile.constructionFrontEnd != 0"
                cols="12"
                lg="4"
                md="6"
                sm="12"
            >
                <v-card @click="goToPipelineFrontEnd" class="frontend_alpha">
                    <v-card-title class="text-h6 frontend d-flex justify-space-between">

                        <div>
                            <v-icon left class="pipelineIconTitle">mdi mdi-grid</v-icon>
                            <label class="pipelineLabelTitle">Front end</label>
                        </div>


                        <div style="text-align: right;">
                            <label class="labelHoldResumeValue"> {{ totalFrontEnd }}</label>
                            <label class="labelHoldResume">Open</label>
                            <label class="pipelineLabelTitle"> | </label>
                            <label class="labelHoldResumeValue">0</label>
                            <label class="labelHoldResume">On Hold</label>
                        </div>       

                    </v-card-title>
                    <v-card-text 
                        class="pipelineDetails"
                    >
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdDigDemo }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_FRONTEND_DIGDEMO.description }}</label>
                                <br v-if="showWorkOrderDigDemo" />
                                <table 
                                    v-if="showWorkOrderDigDemo"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderDigDemo" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdFormSteel }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_FRONTEND_FORMSTEEL.description }}</label>
                                <br v-if="showWorkOrderFormSteel" />
                                <table 
                                    v-if="showWorkOrderFormSteel"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderFormSteel" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdFrontEndInspections }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_FRONTEND_FRONTENDINSPECTION.description }}</label>
                                <br v-if="showWorkOrderFrontEndInspection" />
                                <table 
                                    v-if="showWorkOrderFrontEndInspection"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderFrontEndInspection" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdPrePlumb }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_FRONTEND_PREPLUMB.description }}</label>
                                <br v-if="showWorkOrderPrePlumb" />
                                <table 
                                    v-if="showWorkOrderPrePlumb"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderPrePlumb" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdGunite }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_FRONTEND_GUNITE.description }}</label>
                                <br v-if="showWorkOrderGunite" />
                                <table 
                                    v-if="showWorkOrderGunite"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderGunite" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdBackFill }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_FRONTEND_BACKFILL.description }}</label>
                                <br v-if="showWorkOrderBackFill" />
                                <table 
                                    v-if="showWorkOrderBackFill"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderBackFill" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
            
            <v-col 
                v-if="userLoggedGetters.profile.constructionGradingPlumbing != 0"
                cols="12"
                lg="4"
                md="6"
                sm="12"
            >
                <v-card @click="goToPipelineGradingPlumbing" class="grading_plumbing_alpha">
                    <v-card-title class="text-h6 grading_plumbing d-flex justify-space-between">

                        <div>
                            <v-icon left class="pipelineIconTitle">mdi mdi-pipe</v-icon>
                            <label class="pipelineLabelTitle">Grading / Plumbing</label>
                        </div>                        

                        <div style="text-align: right;">
                            <label class="labelHoldResumeValue"> {{ totalGradingPlumbing }} </label>
                            <label class="labelHoldResume">Open</label>
                            <label class="pipelineLabelTitle"> | </label>
                            <!-- <br /> -->
                            <label class="labelHoldResumeValue">0</label>
                            <label class="labelHoldResume">On Hold</label>
                        </div>

                    </v-card-title>
                    <v-card-text 
                        class="pipelineDetails"
                    >
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdPlumbing }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_GRADINGPLUMBING_PLUMBING.description }}</label>
                                <br v-if="showWorkOrderPlumbing" />
                                <table 
                                    v-if="showWorkOrderPlumbing"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderPlumbing" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>

                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdPlumbingInspection }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_GRADINGPLUMBING_PLUMBINGINSPECTION.description }}</label>
                                <br v-if="showWorkOrderPlumbingInspection" />
                                <table 
                                    v-if="showWorkOrderPlumbingInspection"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderPlumbingInspection" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>

                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdPatioGradeBondingGrid }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_GRADINGPLUMBING_PATIOGRADE.description }}</label>
                                <br v-if="showWorkOrderPatioGrade" />
                                <table 
                                    v-if="showWorkOrderPatioGrade"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderPatioGrade" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdBondingGridInspection }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_GRADINGPLUMBING_DECKBONDINSPECTION.description }}</label>
                                <br v-if="showWorkOrderDeckBondInspection" />
                                <table 
                                    v-if="showWorkOrderDeckBondInspection"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderDeckBondInspection" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValueBlank">-</label>
                            </v-col>
                            <v-col 
                                cols="10"
                            >
                                <label class="pipelineLabelValueBlank">-</label>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValueBlank">-</label>
                            </v-col>
                            <v-col 
                                cols="10"
                            >
                                <label class="pipelineLabelValueBlank">-</label>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
            
            <v-col 
                v-if="userLoggedGetters.profile.constructionTileDeck != 0"
                cols="12"
                lg="4"
                md="6"
                sm="12"
            >
                <v-card @click="goToPipelineTileDeck" class="tiledeck_alpha">
                    <v-card-title class="text-h6 tiledeck d-flex justify-space-between">

                        <div>
                            <v-icon left class="pipelineIconTitle">mdi mdi-wall</v-icon>
                            <label class="pipelineLabelTitle">Brick & Tile / Deck</label>
                        </div>
                        

                        <div style="text-align: right;">
                            <label class="labelHoldResumeValue">{{ totalBrickTileDeck }}</label>
                            <label class="labelHoldResume">Open</label>
                            <label class="pipelineLabelTitle"> | </label>
                            <!-- <br /> -->
                            <label class="labelHoldResumeValue">0</label>
                            <label class="labelHoldResume">On Hold</label>
                        </div>

                    </v-card-title>
                    <v-card-text 
                        class="pipelineDetails"
                    >
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdSendDelivery }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_BRICKTILE_BRICKANDTILEINSTALL.description }}</label>
                                <br v-if="showWorkOrderBrickAndTile" />
                                <table 
                                    v-if="showWorkOrderBrickAndTile"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderBrickAndTile" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>

                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdDeckInstall }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_BRICKTILE_DECKINSTALL.description }}</label>
                                <br v-if="showWorkOrderDeckInstall" />
                                <table 
                                    v-if="showWorkOrderDeckInstall"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderDeckInstall" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdFinalGrade }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_BRICKTILE_FINALGRADE.description }}</label>
                                <br v-if="showWorkOrderFinalGrade" />
                                <table 
                                    v-if="showWorkOrderFinalGrade"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderFinalGrade" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdCleanUp }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_BRICKTILE_CLEANUP.description }}</label>
                                <br v-if="showWorkOrderCleanUp" />
                                <table 
                                    v-if="showWorkOrderCleanUp"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderCleanUp" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdDeckInspections }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_BRICKTILE_DECKINSPECTION.description }}</label>
                                <br v-if="showWorkOrderDeckInspections" />
                                <table 
                                    v-if="showWorkOrderDeckInspections"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderDeckInspections" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col 
                v-if="userLoggedGetters.profile.constructionEquipmentElectric != 0"
                cols="12"
                lg="4"
                md="6"
                sm="12"
            >
                <v-card @click="goToPipelineEquipmentElectric" class="equipment_electric_alpha">
                    <v-card-title class="text-h6 equipment_electric d-flex justify-space-between">

                        <div>
                            <v-icon left class="pipelineIconTitle">mdi mdi-home-lightning-bolt</v-icon>
                            <label class="pipelineLabelTitle">Equipment / Electric</label>
                        </div>                        

                        <div style="text-align: right;">
                            <label class="labelHoldResumeValue">{{ totalEquipmentElectric }}</label>
                            <label class="labelHoldResume">Open</label>
                            <label class="pipelineLabelTitle"> | </label>
                            <label class="labelHoldResumeValue">0</label>
                            <label class="labelHoldResume">On Hold</label>
                        </div>

                    </v-card-title> 
                    <v-card-text 
                        class="pipelineDetails"
                    >
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdEquipmentSet }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_EQUIPMENTELETRIC_EQUIPMENTSET.description }}</label>
                                <br v-if="showWorkOrderEquipmentSet" />
                                <table 
                                    v-if="showWorkOrderEquipmentSet"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderEquipmentSet" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdElectricHookUp }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_EQUIPMENTELETRIC_ELECTRICHOOKUP.description }}</label>
                                <br v-if="showWorkOrderElectricHookUp" />
                                <table 
                                    v-if="showWorkOrderElectricHookUp"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderElectricHookUp" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdPrePlasterResponsabilities }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_EQUIPMENTELETRIC_PREPLASTER.description }}</label>
                                <br v-if="showWorkOrderPrePlasterResponsabilities" />
                                <table 
                                    v-if="showWorkOrderPrePlasterResponsabilities"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderPrePlasterResponsabilities" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdInspections }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_EQUIPMENTELETRIC_INSPECTION.description }}</label>
                                <br v-if="showWorkOrderInspections" />
                                <table 
                                    v-if="showWorkOrderInspections"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderInspections" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValueBlank">-</label>
                            </v-col>
                            <v-col 
                                cols="10"
                            >
                                <label class="pipelineLabelValueBlank">-</label>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col 
                v-if="userLoggedGetters.profile.constructionPrepPlaster != 0"
                cols="12"
                lg="4"
                md="6"
                sm="12"
            >
                <v-card @click="goToPipelinePrepPlaster" class="prep_plaster_alpha">
                    <v-card-title class="text-h6 prep_plaster d-flex justify-space-between">

                        <div>
                            <v-icon left class="pipelineIconTitle">mdi mdi-water-opacity</v-icon>
                            <label class="pipelineLabelTitle">Plaster</label>
                        </div>
                        
                        <div style="text-align: right;">
                            <label class="labelHoldResumeValue">{{ totalPlaste }}</label>
                            <label class="labelHoldResume">Open</label>
                            <label class="pipelineLabelTitle"> | </label>
                            <!-- <br /> -->
                            <label class="labelHoldResumeValue">0</label>
                            <label class="labelHoldResume">On Hold</label>
                        </div>

                    </v-card-title>
                    <v-card-text 
                        class="pipelineDetails"
                    >
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdFinalWalkthrough }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_PLASTE_FINALWALKTHROUGHT.description }}</label>
                                <br v-if="showWorkOrderFinalWalkthrough" />
                                <table 
                                    v-if="showWorkOrderFinalWalkthrough"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderFinalWalkthrough" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdVKBowlDeliveryAndInstall }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_PLASTE_VKBOWLDELIVERY.description }}</label>
                                <br v-if="showWorkOrderVKBowlDeliveryAndInstall" />
                                <table 
                                    v-if="showWorkOrderVKBowlDeliveryAndInstall"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderVKBowlDeliveryAndInstall" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdPrep }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_PLASTE_PREP.description }}</label>
                                <br v-if="showWorkOrderPrep" />
                                <table 
                                    v-if="showWorkOrderPrep"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderPrep" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdPlaster }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_PLASTE_PLASTER.description }}</label>
                                <br v-if="showWorkOrderPlaster" />
                                <table 
                                    v-if="showWorkOrderPlaster"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderPlaster" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdOpenItems }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_PLASTE_OPENITEMS.description }}</label>
                                <br v-if="showWorkOrderOpenItems" />
                                <table 
                                    v-if="showWorkOrderOpenItems"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderOpenItems" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
            
            <v-col 
                v-if="userLoggedGetters.profile.constructionBBQ != 0"
                cols="12"
                lg="4"
                md="6"
                sm="12"
            >
                <v-card @click="goToPipelineFence" class="fence_alpha">
                    <v-card-title class="text-h6 fence d-flex justify-space-between">

                        <div>
                            <v-icon left class="pipelineIconTitle" style="margin-top: -5px;">mdi mdi-fence</v-icon>
                            <label class="pipelineLabelTitle">Fence</label>
                        </div>

                        <div style="text-align: right;">
                            <label class="labelHoldResumeValue"> {{ totalFence }}</label>
                            <label class="labelHoldResume">Open</label>
                            <label class="pipelineLabelTitle"> | </label>
                            <!-- <br /> -->
                            <label class="labelHoldResumeValue">0</label>
                            <label class="labelHoldResume">On Hold</label>
                        </div>
                        
                    </v-card-title>
                    <v-card-text 
                        class="pipelineDetails"
                    >
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdFenceSendPOAndSchedule }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_FENCE_SENDPOANDSCHEDULE.description }}</label>
                                <br v-if="showWorkOrderFenceSendPOAndSchedule" />
                                <table 
                                    v-if="showWorkOrderFenceSendPOAndSchedule"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderFenceSendPOAndSchedule" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdFenceBarrierAndBondInspection }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_FENCE_BARRIERANDBONDINSPECTION.description }}</label>
                                <br v-if="showWorkOrderFenceBarrierAndBondInspection" />
                                <table 
                                    v-if="showWorkOrderFenceBarrierAndBondInspection"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderFenceBarrierAndBondInspection" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdFenceFinalInspection }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_FENCE_FINALINSPECTION.description }}</label>
                                <br v-if="showWorkOrderFenceFinalInspection" />
                                <table 
                                    v-if="showWorkOrderFenceFinalInspection"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderFenceFinalInspection" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col 
                v-if="userLoggedGetters.profile.constructionFence != 0"
                cols="12"
                lg="4"
                md="6"
                sm="12"
            >
                <v-card @click="goToPipelineBBQ" class="bbq_alpha">
                    <v-card-title class="text-h6 bbq d-flex justify-space-between">

                        <div>
                            <v-icon left class="pipelineIconTitle">mdi mdi-grill-outline</v-icon>
                            <label class="pipelineLabelTitle">BBQ</label>
                        </div>

                        <div style="text-align: right;">
                            <label class="labelHoldResumeValue">{{ totalBBQ }}</label>
                            <label class="labelHoldResume">Open</label>
                            <label class="pipelineLabelTitle"> | </label>
                            <!-- <br /> -->
                            <label class="labelHoldResumeValue">0</label>
                            <label class="labelHoldResume">On Hold</label>
                        </div>

                    </v-card-title>
                    <v-card-text 
                        class="pipelineDetails"
                    >
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdBBQUndergroundInspection }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_BBQ_UNDERGROUNDINSPECTION.description }}</label>
                                <br v-if="showWorkOrderBBQUndergroundInspection" />
                                <table 
                                    v-if="showWorkOrderBBQUndergroundInspection"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderBBQUndergroundInspection" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdBBQFrameInstallation }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_BBQ_FRAMEINSTALLATION.description }}</label>
                                <br v-if="showWorkOrderBBQFrameInstallation" />
                                <table 
                                    v-if="showWorkOrderBBQFrameInstallation"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderBBQFrameInstallation" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdBBQFrameAndTieDownInspection }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_BBQ_FRAMEANDTIEDOWNINSPECTION.description }}</label>
                                <br v-if="showWorkOrderBBQFrameAndTieDownInspection" />
                                <table 
                                    v-if="showWorkOrderBBQFrameAndTieDownInspection"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderBBQFrameAndTieDownInspection" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdBBQInstallRoughElectric }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_BBQ_INSTALLROUGHELECTRIC.description }}</label>
                                <br v-if="showWorkOrderBBQInstallRoughElectric" />
                                <table 
                                    v-if="showWorkOrderBBQInstallRoughElectric"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderBBQInstallRoughElectric" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdBBQRoughElectricInspection }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_BBQ_ROUGHELECTRICINSPECTION.description }}</label>
                                <br v-if="showWorkOrderBBQRoughElectricInspection" />
                                <table 
                                    v-if="showWorkOrderBBQRoughElectricInspection"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderBBQRoughElectricInspection" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdBBQDryWallInstallation }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_BBQ_DRYWALLINSTALLATION.description }}</label>
                                <br v-if="showWorkOrderBBQDryWallInstallation" />
                                <table 
                                    v-if="showWorkOrderBBQDryWallInstallation"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderBBQDryWallInstallation" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdBBQDryWallAndTieDownInspection }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_BBQ_DRYWALLANDTIEDOWNINSPECTION.description }}</label>
                                <br v-if="showWorkOrderBBQDryWallAndTieDownInspection" />
                                <table 
                                    v-if="showWorkOrderBBQDryWallAndTieDownInspection"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderBBQDryWallAndTieDownInspection" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdBBQCladdingAndCounterTopInstallation }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_BBQ_CLADDINGANDCOUNTERTOPINSTALLATION.description }}</label>
                                <br v-if="showWorkOrderBBQCladdingAndCounterTopInstallation" />
                                <table 
                                    v-if="showWorkOrderBBQCladdingAndCounterTopInstallation"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderBBQCladdingAndCounterTopInstallation" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdBBQInstallAppliances }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_BBQ_INSTALLAPPLIANCES.description }}</label>
                                <br v-if="showWorkOrderBBQInstallAppliances" />
                                <table 
                                    v-if="showWorkOrderBBQInstallAppliances"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderBBQInstallAppliances" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdBBQFinalElectricInstallation }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_BBQ_FINALELECTRICINSTALLATION.description }}</label>
                                <br v-if="showWorkOrderBBQFinalElectricInstallation" />
                                <table 
                                    v-if="showWorkOrderBBQFinalElectricInstallation"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderBBQFinalElectricInstallation" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdBBQFinalElectricFinalGasFinalPlumbingInspection }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_BBQ_FINALELECTRICFINALGASFINALPLUMBINGINSPECTION.description }}</label>
                                <br v-if="showWorkOrderBBQFinalElectricFinalGasFinalPlumbingInspection" />
                                <table 
                                    v-if="showWorkOrderBBQFinalElectricFinalGasFinalPlumbingInspection"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderBBQFinalElectricFinalGasFinalPlumbingInspection" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdBBQFinalInspection }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_BBQ_FINALINSPECTION.description }}</label>
                                <br v-if="showWorkOrderBBQFinalInspection" />
                                <table 
                                    v-if="showWorkOrderBBQFinalInspection"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderBBQFinalInspection" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col 
                v-if="userLoggedGetters.profile.constructionPergola != 0"
                cols="12"
                lg="4"
                md="6"
                sm="12"
            >
                <v-card @click="goToPipelinePergola" class="pergola_alpha">
                    <v-card-title class="text-h6 pergola d-flex justify-space-between">

                        <div>
                            <v-icon left class="pipelineIconTitle">mdi mdi-home-roof</v-icon>
                            <label class="pipelineLabelTitle">Outdoor</label>
                        </div>

                        <div style="text-align: right;">
                            <label class="labelHoldResumeValue">{{ totalPergola }}</label>
                            <label class="labelHoldResume">Open</label>
                            <label class="pipelineLabelTitle"> | </label>
                            <!-- <br /> -->
                            <label class="labelHoldResumeValue">0</label>
                            <label class="labelHoldResume">On Hold</label>
                        </div>

                    </v-card-title>
                    <v-card-text 
                        class="pipelineDetails"
                    >
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdPergolaFooterFrame }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_PERGOLA_FOOTERFRAME.description }}</label>
                                <br v-if="showWorkOrderPergolaFooterFrame" />
                                <table 
                                    v-if="showWorkOrderPergolaFooterFrame"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderPergolaFooterFrame" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdPergolaInspectionFooterBond }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_PERGOLA_INSPECTIONSFOOTERBONDFOOTERFORMSFOOTERFOUNDATION.description }}</label>
                                <br v-if="showWorkOrderPergolaInspectionFooterBond" />
                                <table 
                                    v-if="showWorkOrderPergolaInspectionFooterBond"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderPergolaInspectionFooterBond" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdPergolaFooterPoured }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_PERGOLA_FOOTERSPOURED.description }}</label>
                                <br v-if="showWorkOrderPergolaFooterPoured" />
                                <table 
                                    v-if="showWorkOrderPergolaFooterPoured"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderPergolaFooterPoured" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdPergolaFooterFinalInspection }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_PERGOLA_FOOTERFINALINSPECTION.description }}</label>
                                <br v-if="showWorkOrderPergolaFooterFinalInspection" />
                                <table 
                                    v-if="showWorkOrderPergolaFooterFinalInspection"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderPergolaFooterFinalInspection" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdPergolaColumnInstallation }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_PERGOLA_COLUMNINSTALLATION.description }}</label>
                                <br v-if="showWorkOrderPergolaColumnInstallation" />
                                <table 
                                    v-if="showWorkOrderPergolaColumnInstallation"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderPergolaColumnInstallation" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdPergolaElectricInstallation }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_PERGOLA_ELECTRICINSTALLATION.description }}</label>
                                <br v-if="showWorkOrderPergolaElectricInstallation" />
                                <table 
                                    v-if="showWorkOrderPergolaElectricInstallation"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderPergolaElectricInstallation" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdPergolaFramingColumn }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_PERGOLA_FRAMINGCOLUMNCOLUMNBONDFINALELECTRICINSPECTION.description }}</label>
                                <br v-if="showWorkOrderPergolaFramingColumn" />
                                <table 
                                    v-if="showWorkOrderPergolaFramingColumn"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderPergolaFramingColumn" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdPergolaFinishInstallation }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_PERGOLA_FINISHINSTALLATION.description }}</label>
                                <br v-if="showWorkOrderPergolaFinishInstallation" />
                                <table 
                                    v-if="showWorkOrderPergolaFinishInstallation"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderPergolaFinishInstallation" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdPergolaFinalInspection }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_PERGOLA_FINALINSPECTION.description }}</label>
                                <br v-if="showWorkOrderPergolaFinalInspection" />
                                <table 
                                    v-if="showWorkOrderPergolaFinalInspection"
                                    style="border: none; width: 100%; margin: 5px;"
                                >
                                    <tr>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Responsible</td>
                                        <td valign="top" style="width: 20%; font-weight: 700;">Customer</td>
                                        <td valign="top" style="width: 40%; font-weight: 700;">Description</td>
                                    </tr>
                                    <tr v-for="(item, index) in listWorkOrderPergolaFinalInspection" :key="index">
                                        <td valign="top">{{ item.name }}</td>
                                        <td valign="top">{{ item.customerName }}</td>
                                        <td valign="top">{{ item.description }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

		<!-- <v-dialog
			v-model="showMyTasks"
			transition="dialog-top-transition"
			persistent
			width="900"
			:fullscreen="$vuetify.breakpoint.mobile"
		>
            <v-card>
				<v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
                    <v-col 
                        cols="6"
                    >
                        My Tasks
                    </v-col>
                </v-card-title>

                <v-card-text style="margin-top: 20px;">

                    <v-row>
                        <v-col
                            cols="12"
                            lg="12"
                            md="12"
                            sm="12"
                        >
                            <v-data-table
                                style="margin-top: 10px;"
                                :headers="headersMyTasks"
                                :items="listMyTasks"
                                :options.sync="optionsMyTasks"
                                :loading="loading"
                                :items-per-page="10"
                                no-data-text="No Record Found"
                            >
                                <template v-slot:item.statusDescription="{ item }">
                                    <v-chip
                                        :color="getTasksStatus(item.status)"
                                        outlined
                                        dark
                                        small
                                    >
                                        {{ item.statusDescription }}
                                    </v-chip>
                                </template>

                                <template v-slot:item.action="{ item }">
                                    <v-menu
                                        left
                                        bottom
                                    >

                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                class="btnActions buttonMoreOptions"
                                                color=""
                                                icon
                                                v-bind="attrs"
                                                v-on="on"
                                            >
                                                <v-icon>mdi-dots-vertical</v-icon>
                                            </v-btn>
                                        </template>

                                        <v-list>
                                            <v-list-item
                                                @click="showDialogActivities(
                                                    item.id,        //idServiceProject
                                                    1,              //idPanel
                                                    1,              //idStage
                                                    0,              //idAction
                                                    0,              //status
                                                    'Pre Site Verification',     //title
                                                    false,          //showScheduleDate
                                                    false,          //showPanelStages
                                                    false,          //showNotes
                                                    false,          //readOnlyNotes
                                                    false,          //showCheckList
                                                    false           //showSubContractor
                                                )"
                                            >
                                                <v-list-item-title><v-icon>mdi mdi-check</v-icon> Check </v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>

                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions 
                    class="justify-center"
                >
                    <v-tooltip 
                        top
                    >
                        <template v-slot:activator="{ on }">
                            <v-btn 
                                class="mx-2 dialogButtonDismiss"
                                v-on="on"
                                @click="showMyTasks = false"
                            >
                                Close
                            </v-btn>
                        </template>
                        <span>Close</span>
                    </v-tooltip>
                </v-card-actions>
            </v-card>
        </v-dialog> -->

        <!-- <v-speed-dial
            fixed
            v-model="openedFloatButton"
            :top="false"
            :bottom="true"
            :right="true"
            :left="false"
            :direction="'top'"
            :transition="'slide-y-reverse-transition'"
        >
            <template v-slot:activator>
                <v-btn
                    class="mx-2"
                    elevation="24"
                    outlined
                    x-large
                    fab
                    style="background-color: var(--color__red) !important; color: white !important;"
                >
                    <v-icon v-if="openedFloatButton">
                        mdi-close
                    </v-icon>
                    <v-icon v-else>
                        mdi-check-all
                    </v-icon>
                </v-btn>
            </template>
            <v-tooltip left>
                <template v-slot:activator="{ on }">
                    <v-btn
                        fab
                        small
                        v-on="on"
                        style="background-color: white !important;"
                        @click="showMyTasks = true" 
                    >
                        <v-icon>mdi-calendar-check-outline</v-icon>
                    </v-btn>
                </template>
                <span>My Tasks</span>
            </v-tooltip>
        </v-speed-dial> -->
        
        <!-- <DialogActivities
            :idServiceProject="dialogActivity.idServiceProject"
            :idPanel="dialogActivity.idPanel"
            :idStage="dialogActivity.idStage"
            :idAction="dialogActivity.idAction"
            :status="dialogActivity.status"
            :title="dialogActivity.title"
            :showScheduleDate="dialogActivity.showScheduleDate"
            :showPanelStages="dialogActivity.showPanelStages"
            :showNotes="dialogActivity.showNotes"
            :readOnlyNotes="dialogActivity.readOnlyNotes"
            :showCheckList="dialogActivity.showCheckList"
            :showSubContractor="dialogActivity.showSubContractor"
            v-on:methodConfirmToCall="dialogActivity.methodConfirm"
            :showDialogActivities.sync="dialogActivity.show"
        /> -->

    </v-container>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Helpers from '@/utilities/Helpers';
    // import DialogActivities from "@/components/Services/DialogActivities";
    import { 
        PROJECT_STATUS,
        CONSTRUCTION_PANEL,
        CONSTRUCTION_STAGE
    } from "@/utilities/Enums";
    import * as moment from 'moment';
    import { orderBy } from '@/utilities/Utils';
    export default ({

        // components: {
        //     DialogActivities
        // },

        mixins: [Helpers],

        data: () => ({

            filter: {
                fastSearch: ''
            },

            //Pre-Dig
            qtdIncoming: 0,
            qtdPreSite: 0,
            qtdLocates: 0,
            qtdPreSiteResponsabilities: 0,
            qtdRebar: 0,

            //Front End
            qtdDigDemo: 0,
            qtdFormSteel: 0,
            qtdFrontEndInspections: 0,
            qtdPrePlumb: 0,
            qtdGunite: 0,
            qtdBackFill: 0,

            //Grading & Plumbing
            qtdPlumbing: 0,
            qtdPlumbingInspection: 0,
            qtdPatioGradeBondingGrid: 0,
            qtdBondingGridInspection: 0,

            //Brick & Tile / Deck
            qtdSendDelivery: 0,
            qtdDeckInstall: 0,
            qtdFinalGrade: 0,
            qtdCleanUp: 0,
            qtdDeckInspections: 0,

            //Equipment & Electric
            qtdEquipmentSet: 0,
            qtdElectricHookUp: 0,
            qtdPrePlasterResponsabilities: 0,
            qtdInspections: 0,

            //Plaster
            qtdFinalWalkthrough: 0,
            qtdVKBowlDeliveryAndInstall: 0,
            qtdPrep: 0,
            qtdPlaster: 0,
            qtdOpenItems: 0,

            //Fence
            qtdFenceSendPOAndSchedule: 0,
            qtdFenceBarrierAndBondInspection: 0,
            qtdFenceFinalInspection: 0,

            //BBQ
            qtdBBQUndergroundInspection: 0,
            qtdBBQFrameInstallation: 0,
            qtdBBQFrameAndTieDownInspection: 0,
            qtdBBQInstallRoughElectric: 0,
            qtdBBQRoughElectricInspection: 0,
            qtdBBQDryWallInstallation: 0,
            qtdBBQDryWallAndTieDownInspection: 0,
            qtdBBQCladdingAndCounterTopInstallation: 0,
            qtdBBQInstallAppliances: 0,
            qtdBBQFinalElectricInstallation: 0,
            qtdBBQFinalElectricFinalGasFinalPlumbingInspection: 0,
            qtdBBQFinalInspection: 0,

            //Pergola
            qtdPergolaFooterFrame: 0,
            qtdPergolaInspectionFooterBond: 0,
            qtdPergolaFooterPoured: 0,
            qtdPergolaFooterFinalInspection: 0,
            qtdPergolaColumnInstallation: 0,
            qtdPergolaElectricInstallation: 0,
            qtdPergolaFramingColumn: 0,
            qtdPergolaFinishInstallation: 0,
            qtdPergolaFinalInspection: 0,            

            openedFloatButton: false,
            showMyTasks: false,

            loading: false,
            
            listMyTasks: [ 
                { id: 1, userNameRegister: 'Rayane Tavares', dateRegisterFormatted: '04/27/2023 09:12', stageDescription: 'Pre-Dig -> Pre Site', actionDescription: 'Pre Site Verification', targetDateFormatted: '04/29/2023', status: 2, statusDescription: 'Scheduled'},
            ],

            headersMyTasks: [
                { text: "ID", value: "id", sortable: true, size: "5%" },
                { text: "Phase", value: "stageDescription", sortable: true },
                { text: "Action", value: "actionDescription", sortable: true },
                { text: "Target", value: "targetDateFormatted", sortable: true },
                { text: "Created By", value: "userNameRegister", sortable: true },
                { text: "Created On", value: "dateRegisterFormatted", sortable: true },
                { text: "Status", value: "statusDescription", sortable: true },
                { text: "Actions", value: "action", sortable: false, align: "center" },
            ],

            optionsMyTasks: { rowsPerPage: 10, page: 1 },

            dialogActivity: {
                idServiceProject: 0,
                idPanel: 0,
                idStage: 0,
                idAction: 0,
                status: 0,
                title: "",
                show: false,
                showScheduleDate: false,
                showPanelStages: false,
                showNotes: false,
                readOnlyNotes: false,
                showCheckList: false,
                showSubContractor: false,
                methodConfirm: ( () => {} ),
            },

            listWorkOrderPreSite: [],
            listWorkOrderLocates: [],
            listWorkOrderPreSiteResp: [],
            listWorkOrderRebar: [],

            listWorkOrderDigDemo: [],
            listWorkOrderFormSteel: [],
            listWorkOrderFrontEndInspection: [],
            listWorkOrderPrePlumb: [],
            listWorkOrderGunite: [],
            listWorkOrderBackFill: [],

            listWorkOrderPlumbing: [],
            listWorkOrderPlumbingInspection: [],
            listWorkOrderPatioGrade: [],
            listWorkOrderDeckBondInspection: [],

            listWorkOrderBrickAndTile: [],
            listWorkOrderDeckInstall: [],
            listWorkOrderFinalGrade: [],
            listWorkOrderCleanUp: [],
            listWorkOrderDeckInspections: [],

            listWorkOrderEquipmentSet: [],
            listWorkOrderElectricHookUp: [],
            listWorkOrderPrePlasterResponsabilities: [],
            listWorkOrderInspections: [],

            listWorkOrderFinalWalkthrough: [],
            listWorkOrderVKBowlDeliveryAndInstall: [],
            listWorkOrderPrep: [],
            listWorkOrderPlaster: [],
            listWorkOrderOpenItems: [],

            listWorkOrderFenceSendPOAndSchedule: [],
            listWorkOrderFenceBarrierAndBondInspection: [],
            listWorkOrderFenceFinalInspection: [],

            listWorkOrderBBQUndergroundInspection: [],
            listWorkOrderBBQFrameInstallation: [],
            listWorkOrderBBQFrameAndTieDownInspection: [],
            listWorkOrderBBQInstallRoughElectric: [],
            listWorkOrderBBQRoughElectricInspection: [],
            listWorkOrderBBQDryWallInstallation: [],
            listWorkOrderBBQDryWallAndTieDownInspection: [],
            listWorkOrderBBQCladdingAndCounterTopInstallation: [],
            listWorkOrderBBQInstallAppliances: [],
            listWorkOrderBBQFinalElectricInstallation: [],
            listWorkOrderBBQFinalElectricFinalGasFinalPlumbingInspection: [],
            listWorkOrderBBQFinalInspection: [],

            listWorkOrderPergolaFooterFrame: [],
            listWorkOrderPergolaInspectionFooterBond: [],
            listWorkOrderPergolaFooterPoured: [],
            listWorkOrderPergolaFooterFinalInspection: [],
            listWorkOrderPergolaColumnInstallation: [],
            listWorkOrderPergolaElectricInstallation: [],
            listWorkOrderPergolaFramingColumn: [],
            listWorkOrderPergolaFinishInstallation: [],
            listWorkOrderPergolaFinalInspection: [],

            PROJECT_STATUS,
            CONSTRUCTION_PANEL,
            CONSTRUCTION_STAGE            
        }),

        computed: {
            ...mapGetters('logInModule', { userLoggedGetters: 'searchState' }),

            totalPreDig() {
                return parseInt(this.qtdIncoming) + 
                       parseInt(this.qtdPreSite) +
                       parseInt(this.qtdLocates) +
                       parseInt(this.qtdPreSiteResponsabilities) +
                       parseInt(this.qtdRebar);
            },

            totalFrontEnd() {
                return parseInt(this.qtdDigDemo) + 
                       parseInt(this.qtdFormSteel) +
                       parseInt(this.qtdFrontEndInspections) +
                       parseInt(this.qtdPrePlumb) +
                       parseInt(this.qtdGunite) +
                       parseInt(this.qtdBackFill);
            },

            totalGradingPlumbing() {
                return parseInt(this.qtdPlumbing) + 
                       parseInt(this.qtdPlumbingInspection) +
                       parseInt(this.qtdPatioGradeBondingGrid) +
                       parseInt(this.qtdBondingGridInspection);
            },

            totalBrickTileDeck() {
                return parseInt(this.qtdSendDelivery) + 
                       parseInt(this.qtdDeckInstall) +
                       parseInt(this.qtdFinalGrade) +
                       parseInt(this.qtdCleanUp) +
                       parseInt(this.qtdDeckInspections);
            },

            totalEquipmentElectric() {
                return parseInt(this.qtdEquipmentSet) + 
                       parseInt(this.qtdElectricHookUp) +
                       parseInt(this.qtdPrePlasterResponsabilities) +
                       parseInt(this.qtdInspections);
            },

            totalPlaste() {
                return parseInt(this.qtdFinalWalkthrough) + 
                       parseInt(this.qtdVKBowlDeliveryAndInstall) +
                       parseInt(this.qtdPrep) +
                       parseInt(this.qtdPlaster) +
                       parseInt(this.qtdOpenItems);
            },

            totalFence() {
                return parseInt(this.qtdFenceSendPOAndSchedule) + 
                       parseInt(this.qtdFenceBarrierAndBondInspection) +
                       parseInt(this.qtdFenceFinalInspection);
            },

            totalBBQ() {
                return parseInt(this.qtdBBQUndergroundInspection) + 
                       parseInt(this.qtdBBQFrameInstallation) + 
                       parseInt(this.qtdBBQFrameAndTieDownInspection) + 
                       parseInt(this.qtdBBQInstallRoughElectric) + 
                       parseInt(this.qtdBBQRoughElectricInspection) + 
                       parseInt(this.qtdBBQDryWallInstallation) + 
                       parseInt(this.qtdBBQDryWallAndTieDownInspection) + 
                       parseInt(this.qtdBBQCladdingAndCounterTopInstallation) + 
                       parseInt(this.qtdBBQInstallAppliances) + 
                       parseInt(this.qtdBBQFinalElectricInstallation) + 
                       parseInt(this.qtdBBQFinalElectricFinalGasFinalPlumbingInspection) + 
                       parseInt(this.qtdBBQFinalInspection)
            },

            totalPergola() {
                return parseInt(this.qtdPergolaFooterFrame) + 
                       parseInt(this.qtdPergolaInspectionFooterBond) + 
                       parseInt(this.qtdPergolaFooterPoured) + 
                       parseInt(this.qtdPergolaFooterFinalInspection) + 
                       parseInt(this.qtdPergolaColumnInstallation) + 
                       parseInt(this.qtdPergolaElectricInstallation) + 
                       parseInt(this.qtdPergolaFramingColumn) + 
                       parseInt(this.qtdPergolaFinishInstallation) + 
                       parseInt(this.qtdPergolaFinalInspection)
            },

            //PRE-DIG
            showWorkOrderPreSite() {
                return this.listWorkOrderPreSite != null && 
                       this.listWorkOrderPreSite != undefined && 
                       this.listWorkOrderPreSite.length > 0;
            },

            showWorkOrderLocates() {
                return this.listWorkOrderLocates != null && 
                       this.listWorkOrderLocates != undefined && 
                       this.listWorkOrderLocates.length > 0;
            },

            showWorkOrderPreSiteResp() {
                return this.listWorkOrderPreSiteResp != null && 
                       this.listWorkOrderPreSiteResp != undefined && 
                       this.listWorkOrderPreSiteResp.length > 0;
            },

            showWorkOrderRebar() {
                return this.listWorkOrderRebar != null && 
                       this.listWorkOrderRebar != undefined && 
                       this.listWorkOrderRebar.length > 0;
            },

            //FRONT-END
            showWorkOrderDigDemo() {
                return this.listWorkOrderDigDemo != null && 
                       this.listWorkOrderDigDemo != undefined && 
                       this.listWorkOrderDigDemo.length > 0;
            },

            showWorkOrderFormSteel() {
                return this.listWorkOrderFormSteel != null && 
                       this.listWorkOrderFormSteel != undefined && 
                       this.listWorkOrderFormSteel.length > 0;
            },

            showWorkOrderFrontEndInspection() {
                return this.listWorkOrderFrontEndInspection != null && 
                       this.listWorkOrderFrontEndInspection != undefined && 
                       this.listWorkOrderFrontEndInspection.length > 0;
            },

            showWorkOrderPrePlumb() {
                return this.listWorkOrderPrePlumb != null && 
                       this.listWorkOrderPrePlumb != undefined && 
                       this.listWorkOrderPrePlumb.length > 0;
            },

            showWorkOrderGunite() {
                return this.listWorkOrderGunite != null && 
                       this.listWorkOrderGunite != undefined && 
                       this.listWorkOrderGunite.length > 0;
            },

            showWorkOrderBackFill() {
                return this.listWorkOrderBackFill != null && 
                       this.listWorkOrderBackFill != undefined && 
                       this.listWorkOrderBackFill.length > 0;
            },

            //GRADING & PLUMBING
            showWorkOrderPlumbing() {
                return this.listWorkOrderPlumbing != null && 
                       this.listWorkOrderPlumbing != undefined && 
                       this.listWorkOrderPlumbing.length > 0;
            },

            showWorkOrderPlumbingInspection() {
                return this.listWorkOrderPlumbingInspection != null && 
                       this.listWorkOrderPlumbingInspection != undefined && 
                       this.listWorkOrderPlumbingInspection.length > 0;
            },

            showWorkOrderPatioGrade() {
                return this.listWorkOrderPatioGrade != null && 
                       this.listWorkOrderPatioGrade != undefined && 
                       this.listWorkOrderPatioGrade.length > 0;
            },

            showWorkOrderDeckBondInspection() {
                return this.listWorkOrderDeckBondInspection != null && 
                       this.listWorkOrderDeckBondInspection != undefined && 
                       this.listWorkOrderDeckBondInspection.length > 0;
            },

            //BRICK & TILE
            showWorkOrderBrickAndTile() {
                return this.listWorkOrderBrickAndTile != null && 
                       this.listWorkOrderBrickAndTile != undefined && 
                       this.listWorkOrderBrickAndTile.length > 0;
            },

            showWorkOrderDeckInstall() {
                return this.listWorkOrderDeckInstall != null && 
                       this.listWorkOrderDeckInstall != undefined && 
                       this.listWorkOrderDeckInstall.length > 0;
            },

            showWorkOrderFinalGrade() {
                return this.listWorkOrderFinalGrade != null && 
                       this.listWorkOrderFinalGrade != undefined && 
                       this.listWorkOrderFinalGrade.length > 0;
            },

            showWorkOrderCleanUp() {
                return this.listWorkOrderCleanUp != null && 
                       this.listWorkOrderCleanUp != undefined && 
                       this.listWorkOrderCleanUp.length > 0;
            },

            showWorkOrderDeckInspections() {
                return this.listWorkOrderDeckInspections != null && 
                       this.listWorkOrderDeckInspections != undefined && 
                       this.listWorkOrderDeckInspections.length > 0;
            },

            //EQUIPMENT & ELECTRIC
            showWorkOrderEquipmentSet() {
                return this.listWorkOrderEquipmentSet != null && 
                       this.listWorkOrderEquipmentSet != undefined && 
                       this.listWorkOrderEquipmentSet.length > 0;
            },

            showWorkOrderElectricHookUp() {
                return this.listWorkOrderElectricHookUp != null && 
                       this.listWorkOrderElectricHookUp != undefined && 
                       this.listWorkOrderElectricHookUp.length > 0;
            },

            showWorkOrderPrePlasterResponsabilities() {
                return this.listWorkOrderPrePlasterResponsabilities != null && 
                       this.listWorkOrderPrePlasterResponsabilities != undefined && 
                       this.listWorkOrderPrePlasterResponsabilities.length > 0;
            },

            showWorkOrderInspections() {
                return this.listWorkOrderInspections != null && 
                       this.listWorkOrderInspections != undefined && 
                       this.listWorkOrderInspections.length > 0;
            },

            //PLASTER
            showWorkOrderFinalWalkthrough() {
                return this.listWorkOrderFinalWalkthrough != null && 
                       this.listWorkOrderFinalWalkthrough != undefined && 
                       this.listWorkOrderFinalWalkthrough.length > 0;
            },

            showWorkOrderVKBowlDeliveryAndInstall() {
                return this.listWorkOrderVKBowlDeliveryAndInstall != null && 
                       this.listWorkOrderVKBowlDeliveryAndInstall != undefined && 
                       this.listWorkOrderVKBowlDeliveryAndInstall.length > 0;
            },

            showWorkOrderPrep() {
                return this.listWorkOrderPrep != null && 
                       this.listWorkOrderPrep != undefined && 
                       this.listWorkOrderPrep.length > 0;
            },

            showWorkOrderPlaster() {
                return this.listWorkOrderPlaster != null && 
                       this.listWorkOrderPlaster != undefined && 
                       this.listWorkOrderPlaster.length > 0;
            },

            showWorkOrderOpenItems() {
                return this.listWorkOrderOpenItems != null && 
                       this.listWorkOrderOpenItems != undefined && 
                       this.listWorkOrderOpenItems.length > 0;
            },

            //FENCE
            showWorkOrderFenceSendPOAndSchedule() {
                return this.listWorkOrderFenceSendPOAndSchedule != null && 
                       this.listWorkOrderFenceSendPOAndSchedule != undefined && 
                       this.listWorkOrderFenceSendPOAndSchedule.length > 0;
            },

            showWorkOrderFenceBarrierAndBondInspection() {
                return this.listWorkOrderFenceBarrierAndBondInspection != null && 
                       this.listWorkOrderFenceBarrierAndBondInspection != undefined && 
                       this.listWorkOrderFenceBarrierAndBondInspection.length > 0;
            },

            showWorkOrderFenceFinalInspection() {
                return this.listWorkOrderFenceFinalInspection != null && 
                       this.listWorkOrderFenceFinalInspection != undefined && 
                       this.listWorkOrderFenceFinalInspection.length > 0;
            },

            //BBQ
            showWorkOrderBBQUndergroundInspection() {
                return this.listWorkOrderBBQUndergroundInspection != null && 
                       this.listWorkOrderBBQUndergroundInspection != undefined && 
                       this.listWorkOrderBBQUndergroundInspection.length > 0;
            },

            showWorkOrderBBQFrameInstallation() {
                return this.listWorkOrderBBQFrameInstallation != null && 
                       this.listWorkOrderBBQFrameInstallation != undefined && 
                       this.listWorkOrderBBQFrameInstallation.length > 0;
            },

            showWorkOrderBBQFrameAndTieDownInspection() {
                return this.listWorkOrderBBQFrameAndTieDownInspection != null && 
                       this.listWorkOrderBBQFrameAndTieDownInspection != undefined && 
                       this.listWorkOrderBBQFrameAndTieDownInspection.length > 0;
            },

            showWorkOrderBBQInstallRoughElectric() {
                return this.listWorkOrderBBQInstallRoughElectric != null && 
                       this.listWorkOrderBBQInstallRoughElectric != undefined && 
                       this.listWorkOrderBBQInstallRoughElectric.length > 0;
            },

            showWorkOrderBBQRoughElectricInspection() {
                return this.listWorkOrderBBQRoughElectricInspection != null && 
                       this.listWorkOrderBBQRoughElectricInspection != undefined && 
                       this.listWorkOrderBBQRoughElectricInspection.length > 0;
            },

            showWorkOrderBBQDryWallInstallation() {
                return this.listWorkOrderBBQDryWallInstallation != null && 
                       this.listWorkOrderBBQDryWallInstallation != undefined && 
                       this.listWorkOrderBBQDryWallInstallation.length > 0;
            },

            showWorkOrderBBQDryWallAndTieDownInspection() {
                return this.listWorkOrderBBQDryWallAndTieDownInspection != null && 
                       this.listWorkOrderBBQDryWallAndTieDownInspection != undefined && 
                       this.listWorkOrderBBQDryWallAndTieDownInspection.length > 0;
            },

            showWorkOrderBBQCladdingAndCounterTopInstallation() {
                return this.listWorkOrderBBQCladdingAndCounterTopInstallation != null && 
                       this.listWorkOrderBBQCladdingAndCounterTopInstallation != undefined && 
                       this.listWorkOrderBBQCladdingAndCounterTopInstallation.length > 0;
            },

            showWorkOrderBBQInstallAppliances() {
                return this.listWorkOrderBBQInstallAppliances != null && 
                       this.listWorkOrderBBQInstallAppliances != undefined && 
                       this.listWorkOrderBBQInstallAppliances.length > 0;
            },

            showWorkOrderBBQFinalElectricInstallation() {
                return this.listWorkOrderBBQFinalElectricInstallation != null && 
                       this.listWorkOrderBBQFinalElectricInstallation != undefined && 
                       this.listWorkOrderBBQFinalElectricInstallation.length > 0;
            },

            showWorkOrderBBQFinalElectricFinalGasFinalPlumbingInspection() {
                return this.listWorkOrderBBQFinalElectricFinalGasFinalPlumbingInspection != null && 
                       this.listWorkOrderBBQFinalElectricFinalGasFinalPlumbingInspection != undefined && 
                       this.listWorkOrderBBQFinalElectricFinalGasFinalPlumbingInspection.length > 0;

            },

            showWorkOrderBBQFinalInspection() {
                return this.listWorkOrderBBQFinalInspection != null && 
                       this.listWorkOrderBBQFinalInspection != undefined && 
                       this.listWorkOrderBBQFinalInspection.length > 0;
            },

            //PERGOLA
            showWorkOrderPergolaFooterFrame() {
                return this.listWorkOrderPergolaFooterFrame != null && 
                       this.listWorkOrderPergolaFooterFrame != undefined && 
                       this.listWorkOrderPergolaFooterFrame.length > 0;
            },

            showWorkOrderPergolaInspectionFooterBond() {
                return this.listWorkOrderPergolaInspectionFooterBond != null && 
                       this.listWorkOrderPergolaInspectionFooterBond != undefined && 
                       this.listWorkOrderPergolaInspectionFooterBond.length > 0;
            },

            showWorkOrderPergolaFooterPoured() {
                return this.listWorkOrderPergolaFooterPoured != null && 
                       this.listWorkOrderPergolaFooterPoured != undefined && 
                       this.listWorkOrderPergolaFooterPoured.length > 0;
            },

            showWorkOrderPergolaFooterFinalInspection() {
                return this.listWorkOrderPergolaFooterFinalInspection != null && 
                       this.listWorkOrderPergolaFooterFinalInspection != undefined && 
                       this.listWorkOrderPergolaFooterFinalInspection.length > 0;
            },

            showWorkOrderPergolaColumnInstallation() {
                return this.listWorkOrderPergolaColumnInstallation != null && 
                       this.listWorkOrderPergolaColumnInstallation != undefined && 
                       this.listWorkOrderPergolaColumnInstallation.length > 0;
            },

            showWorkOrderPergolaElectricInstallation() {
                return this.listWorkOrderPergolaElectricInstallation != null && 
                       this.listWorkOrderPergolaElectricInstallation != undefined && 
                       this.listWorkOrderPergolaElectricInstallation.length > 0;
            },

            showWorkOrderPergolaFramingColumn() {
                return this.listWorkOrderPergolaFramingColumn != null && 
                       this.listWorkOrderPergolaFramingColumn != undefined && 
                       this.listWorkOrderPergolaFramingColumn.length > 0;
            },

            showWorkOrderPergolaFinishInstallation() {
                return this.listWorkOrderPergolaFinishInstallation != null && 
                       this.listWorkOrderPergolaFinishInstallation != undefined && 
                       this.listWorkOrderPergolaFinishInstallation.length > 0;
            },

            showWorkOrderPergolaFinalInspection() {
                return this.listWorkOrderPergolaFinalInspection != null && 
                       this.listWorkOrderPergolaFinalInspection != undefined && 
                       this.listWorkOrderPergolaFinalInspection.length > 0;
            },            
        },

        methods: {

            async getRegistersPreDig(listPipeline) {

                let listIncomingProjects = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_PREDIG_INCOMING_PROJECTS.id)];
                if (listIncomingProjects != null && listIncomingProjects != undefined) {
                    this.qtdIncoming = listIncomingProjects.length;
                }

                let listPreSite = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_PREDIG_PRESITE.id)];
                if (listPreSite != null && listPreSite != undefined) {
                    this.qtdPreSite = listPreSite.length;
                }

                let listLocates = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_PREDIG_LOCALES.id)];
                if (listLocates != null && listLocates != undefined) {
                    this.qtdLocates = listLocates.length;
                }

                let listPreSiteResponsabilities = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_PREDIG_PRESITE_RESP.id)];
                if (listPreSiteResponsabilities != null && listPreSiteResponsabilities != undefined) {
                    this.qtdPreSiteResponsabilities = listPreSiteResponsabilities.length;
                }

                let listRebar = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_PREDIG_REBAR.id)];
                if (listRebar != null && listRebar != undefined) {
                    this.qtdRebar = listRebar.length;
                }
            },

            async getRegistersFrontEnd(listPipeline) {

                let listDigDemo = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_FRONTEND_DIGDEMO.id)];
                if (listDigDemo != null && listDigDemo != undefined) {
                    this.qtdDigDemo = listDigDemo.length;
                }

                let listFormSteel = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_FRONTEND_FORMSTEEL.id)];
                if (listFormSteel != null && listFormSteel != undefined) {
                    this.qtdFormSteel = listFormSteel.length;
                }

                let listFrontEndInspections = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_FRONTEND_FRONTENDINSPECTION.id)];
                if (listFrontEndInspections != null && listFrontEndInspections != undefined) {
                    this.qtdFrontEndInspections = listFrontEndInspections.length;
                }

                let listPrePlumb = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_FRONTEND_PREPLUMB.id)];
                if (listPrePlumb != null && listPrePlumb != undefined) {
                    this.qtdPrePlumb = listPrePlumb.length;
                }

                let listGunite = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_FRONTEND_GUNITE.id)];
                if (listGunite != null && listGunite != undefined) {
                    this.qtdGunite = listGunite.length;
                }

                let listBackFill = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_FRONTEND_BACKFILL.id)];
                if (listBackFill != null && listBackFill != undefined) {
                    this.qtdBackFill = listBackFill.length;
                }
            },

            async getRegistersGradingPlumbing(listPipeline) {

                let listPlumbing = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_GRADINGPLUMBING_PLUMBING.id)];
                if (listPlumbing != null && listPlumbing != undefined) {
                    this.qtdPlumbing = listPlumbing.length;
                }

                let listPlumbingInspection = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_GRADINGPLUMBING_PLUMBINGINSPECTION.id)];
                if (listPlumbingInspection != null && listPlumbingInspection != undefined) {
                    this.qtdPlumbingInspection = listPlumbingInspection.length;
                }

                let listPatioGradeBondingGrid = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_GRADINGPLUMBING_PATIOGRADE.id)];
                if (listPatioGradeBondingGrid != null && listPatioGradeBondingGrid != undefined) {
                    this.qtdPatioGradeBondingGrid = listPatioGradeBondingGrid.length;
                }

                let listBondingGridInspection = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_GRADINGPLUMBING_DECKBONDINSPECTION.id)];
                if (listBondingGridInspection != null && listBondingGridInspection != undefined) {
                    this.qtdBondingGridInspection = listBondingGridInspection.length;
                }
            },

            async getRegistersBrickTileDeck(listPipeline) {
                
                let listSendDelivery = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_BRICKTILE_BRICKANDTILEINSTALL.id)];
                if (listSendDelivery != null && listSendDelivery != undefined) {
                    this.qtdSendDelivery = listSendDelivery.length;
                }

                let listDeckInstall = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_BRICKTILE_DECKINSTALL.id)];
                if (listDeckInstall != null && listDeckInstall != undefined) {
                    this.qtdDeckInstall = listDeckInstall.length;
                }

                let listFinalGrade = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_BRICKTILE_FINALGRADE.id)];
                if (listFinalGrade != null && listFinalGrade != undefined) {
                    this.qtdFinalGrade = listFinalGrade.length;
                }

                let listCleanUp = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_BRICKTILE_CLEANUP.id)];
                if (listCleanUp != null && listCleanUp != undefined) {
                    this.qtdCleanUp = listCleanUp.length;
                }

                let listDeckInspections = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_BRICKTILE_DECKINSPECTION.id)];
                if (listDeckInspections != null && listDeckInspections != undefined) {
                    this.qtdDeckInspections = listDeckInspections.length;
                }
            },

            async getRegistersEquipmentElectric(listPipeline) {
                
                let listEquipmentSet = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_EQUIPMENTELETRIC_EQUIPMENTSET.id)];
                if (listEquipmentSet != null && listEquipmentSet != undefined) {
                    this.qtdEquipmentSet = listEquipmentSet.length;
                }

                let listElectricHookUp = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_EQUIPMENTELETRIC_ELECTRICHOOKUP.id)];
                if (listElectricHookUp != null && listElectricHookUp != undefined) {
                    this.qtdElectricHookUp = listElectricHookUp.length;
                }

                let listPrePlasterResponsabilities = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_EQUIPMENTELETRIC_PREPLASTER.id)];
                if (listPrePlasterResponsabilities != null && listPrePlasterResponsabilities != undefined) {
                    this.qtdPrePlasterResponsabilities = listPrePlasterResponsabilities.length;
                }

                let listInspections = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_EQUIPMENTELETRIC_INSPECTION.id)];
                if (listInspections != null && listInspections != undefined) {
                    this.qtdInspections = listInspections.length;
                }
            },

            async getRegistersPlaste(listPipeline) {

                let listFinalWalkthrough = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_PLASTE_FINALWALKTHROUGHT.id)];
                if (listFinalWalkthrough != null && listFinalWalkthrough != undefined) {
                    this.qtdFinalWalkthrough = listFinalWalkthrough.length;
                }

                let listVKBowlDeliveryAndInstall = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_PLASTE_VKBOWLDELIVERY.id)];
                if (listVKBowlDeliveryAndInstall != null && listVKBowlDeliveryAndInstall != undefined) {
                    this.qtdVKBowlDeliveryAndInstall = listVKBowlDeliveryAndInstall.length;
                }

                let listPrep = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_PLASTE_PREP.id)];
                if (listPrep != null && listPrep != undefined) {
                    this.qtdPrep = listPrep.length;
                }

                let listPlaster = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_PLASTE_PLASTER.id)];
                if (listPlaster != null && listPlaster != undefined) {
                    this.qtdPlaster = listPlaster.length;
                }

                let listOpenItems = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_PLASTE_OPENITEMS.id)];
                if (listOpenItems != null && listOpenItems != undefined) {
                    this.qtdOpenItems = listOpenItems.length;
                }
            },

            async getRegistersFence(listPipeline) {

                let listSendPOAndSchedule = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_FENCE_SENDPOANDSCHEDULE.id)];
                if (listSendPOAndSchedule != null && listSendPOAndSchedule != undefined) {
                    this.qtdSendPOAndSchedule = listSendPOAndSchedule.length;
                }

                let listBarrierAndBondInspection = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_FENCE_BARRIERANDBONDINSPECTION.id)];
                if (listBarrierAndBondInspection != null && listBarrierAndBondInspection != undefined) {
                    this.qtdBarrierAndBondInspection = listBarrierAndBondInspection.length;
                }

                let listFinalInspection = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_FENCE_FINALINSPECTION.id)];
                if (listFinalInspection != null && listFinalInspection != undefined) {
                    this.qtdFinalInspection = listFinalInspection.length;
                }
            },

            async getRegistersBBQ(listPipeline) {

                let listUndergroundInspection = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_BBQ_UNDERGROUNDINSPECTION.id)];
                if (listUndergroundInspection != null && listUndergroundInspection != undefined) {
                    this.qtdBBQUndergroundInspection = listUndergroundInspection.length;
                }

                let listFrameInstallation = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_BBQ_FRAMEINSTALLATION.id)];
                if (listFrameInstallation != null && listFrameInstallation != undefined) {
                    this.qtdBBQFrameInstallation = listFrameInstallation.length;
                }

                let listFrameAndTieDownInspection = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_BBQ_FRAMEANDTIEDOWNINSPECTION.id)];
                if (listFrameAndTieDownInspection != null && listFrameAndTieDownInspection != undefined) {
                    this.qtdBBQFrameAndTieDownInspection = listFrameAndTieDownInspection.length;
                }

                let listInstallRoughElectric = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_BBQ_INSTALLROUGHELECTRIC.id)];
                if (listInstallRoughElectric != null && listInstallRoughElectric != undefined) {
                    this.qtdBBQInstallRoughElectric = listInstallRoughElectric.length;
                }

                let listRoughElectricInspection = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_BBQ_ROUGHELECTRICINSPECTION.id)];
                if (listRoughElectricInspection != null && listRoughElectricInspection != undefined) {
                    this.qtdBBQRoughElectricInspection = listRoughElectricInspection.length;
                }

                let listDryWallInstallation = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_BBQ_DRYWALLINSTALLATION.id)];
                if (listDryWallInstallation != null && listDryWallInstallation != undefined) {
                    this.qtdBBQDryWallInstallation = listDryWallInstallation.length;
                }

                let listDryWallAndTieDownInspection = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_BBQ_DRYWALLANDTIEDOWNINSPECTION.id)];
                if (listDryWallAndTieDownInspection != null && listDryWallAndTieDownInspection != undefined) {
                    this.qtdBBQDryWallAndTieDownInspection = listDryWallAndTieDownInspection.length;
                }

                let listCladdingAndCounterTopInstallation = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_BBQ_CLADDINGANDCOUNTERTOPINSTALLATION.id)];
                if (listCladdingAndCounterTopInstallation != null && listCladdingAndCounterTopInstallation != undefined) {
                    this.qtdBBQCladdingAndCounterTopInstallation = listCladdingAndCounterTopInstallation.length;
                }

                let listInstallAppliances = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_BBQ_INSTALLAPPLIANCES.id)];
                if (listInstallAppliances != null && listInstallAppliances != undefined) {
                    this.qtdBBQInstallAppliances = listInstallAppliances.length;
                }

                let listFinalElectricInstallation = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_BBQ_FINALELECTRICINSTALLATION.id)];
                if (listFinalElectricInstallation != null && listFinalElectricInstallation != undefined) {
                    this.qtdBBQFinalElectricInstallation = listFinalElectricInstallation.length;
                }

                let listFinalElectricFinalGasFinalPlumbingInspection = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_BBQ_FINALELECTRICFINALGASFINALPLUMBINGINSPECTION.id)];
                if (listFinalElectricFinalGasFinalPlumbingInspection != null && listFinalElectricFinalGasFinalPlumbingInspection != undefined) {
                    this.qtdBBQFinalElectricFinalGasFinalPlumbingInspection = listFinalElectricFinalGasFinalPlumbingInspection.length;
                }

                let listFinalInspection = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_BBQ_FINALINSPECTION.id)];
                if (listFinalInspection != null && listFinalInspection != undefined) {
                    this.qtdBBQFinalInspection = listFinalInspection.length;
                }
            },

            async getRegistersPergola(listPipeline) {

                let listFooterFrame = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_PERGOLA_FOOTERFRAME.id)];
                if (listFooterFrame != null && listFooterFrame != undefined) {
                    this.qtdPergolaFooterFrame = listFooterFrame.length;
                }

                let listInspectionFooterBond = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_PERGOLA_INSPECTIONSFOOTERBONDFOOTERFORMSFOOTERFOUNDATION.id)];
                if (listInspectionFooterBond != null && listInspectionFooterBond != undefined) {
                    this.qtdPergolaPergolaInspectionFooterBond = listInspectionFooterBond.length;
                }

                let listFooterPoured = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_PERGOLA_FOOTERSPOURED.id)];
                if (listFooterPoured != null && listFooterPoured != undefined) {
                    this.qtdPergolaFooterPoured = listFooterPoured.length;
                }

                let listFooterFinalInspection = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_PERGOLA_FOOTERFINALINSPECTION.id)];
                if (listFooterFinalInspection != null && listFooterFinalInspection != undefined) {
                    this.qtdPergolaFooterFinalInspection = listFooterFinalInspection.length;
                }

                let listColumnInstallation = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_PERGOLA_COLUMNINSTALLATION.id)];
                if (listColumnInstallation != null && listColumnInstallation != undefined) {
                    this.qtdPergolaColumnInstallation = listColumnInstallation.length;
                }

                let listElectricInstallation = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_PERGOLA_ELECTRICINSTALLATION.id)];
                if (listElectricInstallation != null && listElectricInstallation != undefined) {
                    this.qtdPergolaElectricInstallation = listElectricInstallation.length;
                }

                let listFramingColumn = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_PERGOLA_FRAMINGCOLUMNCOLUMNBONDFINALELECTRICINSPECTION.id)];
                if (listFramingColumn != null && listFramingColumn != undefined) {
                    this.qtdPergolaFramingColumn = listFramingColumn.length;
                }

                let listFinishInstallation = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_PERGOLA_FINISHINSTALLATION.id)];
                if (listFinishInstallation != null && listFinishInstallation != undefined) {
                    this.qtdPergolaFinishInstallation = listFinishInstallation.length;
                }

                let listFinalInspection = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_PERGOLA_FINALINSPECTION.id)];
                if (listFinalInspection != null && listFinalInspection != undefined) {
                    this.qtdPergolaFinalInspection = listFinalInspection.length;
                }
            },

            async getRegisters() {

                let response = await this.$store.dispatch("serviceModule/ListPipelineConstruction");

                if (response != null && response != undefined) {

                    if (response.listPipeline && response.listPipeline != null && response.listPipeline != undefined) {
                        this.getRegistersPreDig(response.listPipeline);
                        this.getRegistersFrontEnd(response.listPipeline);
                        this.getRegistersGradingPlumbing(response.listPipeline);
                        this.getRegistersBrickTileDeck(response.listPipeline);
                        this.getRegistersEquipmentElectric(response.listPipeline);
                        this.getRegistersPlaste(response.listPipeline);
                        this.getRegistersFence(response.listPipeline);
                        this.getRegistersBBQ(response.listPipeline);
                        this.getRegistersPergola(response.listPipeline);
                    }
                }
                
                await this.filterWorkOrder();
                await this.filterInspection();
                await this.loadPreDig();
                await this.loadFrontEnd();
                await this.loadGradingPlumbing();
                await this.loadBrickTileDeck();
                await this.loadEquipmentElectric();
                await this.loadPlaster();
                await this.loadFence();
                await this.loadBBQ();
                await this.loadPergola();
            },

            async goToPipelinePreDig() {
                this.$router.push({ path: "/construction/pipelinePreDig" });
            },

            async goToPipelineFrontEnd() {
                this.$router.push({ path: "/construction/pipelineFrontEnd" });
            },

            async goToPipelineGradingPlumbing() {
                this.$router.push({ path: "/construction/pipelineGradingPlumbing" });
            },

            async goToPipelineTileDeck() {
                this.$router.push({ path: "/construction/pipelineTileDeck" });
            },

            async goToPipelineEquipmentElectric() {
                this.$router.push({ path: "/construction/pipelineEquipmentElectric" });
            },

            async goToPipelinePrepPlaster() {
                this.$router.push({ path: "/construction/pipelinePrepPlaster" });
            },

            async goToPipelineFence() {
                this.$router.push({ path: "/construction/pipelineFence" });
            },

            async goToPipelineBBQ() {
                this.$router.push({ path: "/construction/pipelineBBQ" });
            },

            async goToPipelinePergola() {
                this.$router.push({ path: "/construction/pipelinePergola" });
            },
			
            getTasksStatus (status) {

                let color = "";

                switch (status) {

                    case 1:
                        color = 'var(--color__status_pending)';
                        break;

                    case 2:
                        color = 'var(--color__main)';
                        break;

                    case 3:
                        color = 'var(--color__completed)';
                        break;

                    case 4:
                        color = 'var(--color__red)';
                        break;

                    default:
                        color = 'var(--color__main)';
                        break;
                }

                return color
            },

            async showDialogActivities(
                idServiceProject, 
                idPanel, 
                idStage, 
                idAction, 
                status, 
                title, 
                showScheduleDate, 
                showPanelStages, 
                showNotes, 
                readOnlyNotes, 
                showCheckList, 
                showSubContractor
            ) {
                
                this.dialogActivity = {
                    idServiceProject,
                    idPanel: idPanel,
                    idStage: idStage,
                    idAction: idAction,
                    status: status,
                    title: title,
                    show: true,
                    showScheduleDate,
                    showPanelStages,
                    showNotes,
                    readOnlyNotes,
                    showCheckList,
                    showSubContractor,
                    methodConfirm: () => {}
                }
            },

            async filterWorkOrder() {
                const listWorkOrder = await this.$store.dispatch("workOrderModule/ListTodaySchedule");
                this.dateFilter = `${moment().clone().format('YYYY-MM-DD')}T00:00:00`;
                const listWorkOrderFiltered = listWorkOrder.filter(wor => wor.status != 2 && ( ( wor.targetDate >= this.dateFilter && wor.targetDate <= this.dateFilter) || (wor.targetDate == null || wor.targetDate == undefined) || (wor.age < 0)) );
                this.listWorkOrder = listWorkOrderFiltered.sort((a, b) => { return orderBy(a, b, 0, 'todayScheduleOrder') });
            },

            async filterInspection() {
                const listInspection = await this.$store.dispatch("inspectionModule/ListTodaySchedule");
                this.dateFilter = `${moment().clone().format('YYYY-MM-DD')}T00:00:00`;
                const listInspectionFiltered = listInspection.filter(ins => ins.status != 3 && ( (ins.targetDate >= this.dateFilter && ins.targetDate <= this.dateFilter) || (ins.targetDate == null || ins.targetDate == undefined) || (ins.age < 0) ));
                this.listInspectionFiltered = listInspectionFiltered.sort((a, b) => { return orderBy(a, b, 0, 'todayScheduleOrder') });
            },

            async loadPreDig() {
                this.listWorkOrderPreSite = [];
                const listPreSite = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.PREDIG_PRESITE)];
                listPreSite.forEach(item => {
                    this.listWorkOrderPreSite.push(this.addDetail(item));
                });

                this.listWorkOrderLocates = [];
                const listLocates = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.PREDIG_LOCALES)];
                listLocates.forEach(item => {
                    this.listWorkOrderLocates.push(this.addDetail(item));
                });

                this.listWorkOrderPreSiteResp = [];
                const listPreSiteResp = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.PREDIG_PRESITE_RESP)];
                listPreSiteResp.forEach(item => {
                    this.listWorkOrderPreSiteResp.push(this.addDetail(item));
                });

                this.listWorkOrderRebar = [];
                const listRebar = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.PREDIG_REBAR)];
                listRebar.forEach(item => {
                    this.listWorkOrderRebar.push(this.addDetail(item));
                });
            },

            async loadFrontEnd() {
                this.listWorkOrderDigDemo = [];
                const listDigDemo = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.FRONTEND_DIGDEMO)];
                listDigDemo.forEach(item => {
                    this.listWorkOrderDigDemo.push(this.addDetail(item));
                });
                
                this.listWorkOrderFormSteel = [];
                const listFormSteel = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.FRONTEND_FORMSTEEL)];
                listFormSteel.forEach(item => {
                    this.listWorkOrderFormSteel.push(this.addDetail(item));
                });
                
                this.listWorkOrderFrontEndInspection = [];
                const listFrontEndInspection = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.FRONTEND_FRONTENDINSPECTION)];
                listFrontEndInspection.forEach(item => {
                    this.listWorkOrderFrontEndInspection.push(this.addDetail(item));
                });
                
                this.listWorkOrderPrePlumb = [];
                const listPrePlumb = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.FRONTEND_PREPLUMB)];
                listPrePlumb.forEach(item => {
                    this.listWorkOrderPrePlumb.push(this.addDetail(item));
                });
                
                this.listWorkOrderGunite = [];
                const listGunite = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.FRONTEND_GUNITE)];
                listGunite.forEach(item => {
                    this.listWorkOrderGunite.push(this.addDetail(item));
                });
                
                this.listWorkOrderBackFill = [];
                const listBackFill = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.FRONTEND_BACKFILL)];
                listBackFill.forEach(item => {
                    this.listWorkOrderBackFill.push(this.addDetail(item));
                });
            },

            async loadGradingPlumbing() {
                this.listWorkOrderPlumbing = [];
                const listPlumbing = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.GRADINGPLUMBING_PLUMBING)];
                listPlumbing.forEach(item => {
                    this.listWorkOrderPlumbing.push(this.addDetail(item));
                });

                this.listWorkOrderPlumbingInspection = [];
                const listPlumbingInspection = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.GRADINGPLUMBING_PLUMBINGINSPECTION)];
                listPlumbingInspection.forEach(item => {
                    this.listWorkOrderPlumbingInspection.push(this.addDetail(item));
                });

                this.listWorkOrderPatioGrade = [];
                const listPatioGrade = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.GRADINGPLUMBING_PATIOGRADE)];
                listPatioGrade.forEach(item => {
                    this.listWorkOrderPatioGrade.push(this.addDetail(item));
                });

                this.listWorkOrderDeckBondInspection = [];
                const listDeckBondInspection = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.GRADINGPLUMBING_DECKBONDINSPECTION)];
                listDeckBondInspection.forEach(item => {
                    this.listWorkOrderDeckBondInspection.push(this.addDetail(item));
                });
            },

            async loadBrickTileDeck() {
                this.listWorkOrderBrickAndTile = [];
                const listBrickAndTile = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.BRICKTILE_SENDDELIVERY)];
                listBrickAndTile.forEach(item => {
                    this.listWorkOrderBrickAndTile.push(this.addDetail(item));
                });

                this.listWorkOrderDeckInstall = [];
                const listDeckInstall = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.BRICKTILE_DECKINSTALL)];
                listDeckInstall.forEach(item => {
                    this.listWorkOrderDeckInstall.push(this.addDetail(item));
                });

                this.listWorkOrderFinalGrade = [];
                const listFinalGrade = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.BRICKTILE_FINALGRADE)];
                listFinalGrade.forEach(item => {
                    this.listWorkOrderFinalGrade.push(this.addDetail(item));
                });

                this.listWorkOrderCleanUp = [];
                const listCleanUp = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.BRICKTILE_CLEANUP)];
                listCleanUp.forEach(item => {
                    this.listWorkOrderCleanUp.push(this.addDetail(item));
                });

                this.listWorkOrderDeckInspections = [];
                const listDeckInspections = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.BRICKTILE_DECKINSPECTION)];
                listDeckInspections.forEach(item => {
                    this.listWorkOrderDeckInspections.push(this.addDetail(item));
                });
            },

            async loadEquipmentElectric() {
                this.listWorkOrderEquipmentSet = [];
                const listEquipmentSet = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.EQUIPMENTELETRIC_EQUIPMENTSET)];
                listEquipmentSet.forEach(item => {
                    this.listWorkOrderEquipmentSet.push(this.addDetail(item));
                });

                this.listWorkOrderElectricHookUp = [];
                const listElectricHookUp = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.EQUIPMENTELETRIC_ELECTRICHOOKUP)];
                listElectricHookUp.forEach(item => {
                    this.listWorkOrderElectricHookUp.push(this.addDetail(item));
                });

                this.listWorkOrderPrePlasterResp = [];
                const listPrePlasterResp = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.EQUIPMENTELETRIC_PREPLASTER)];
                listPrePlasterResp.forEach(item => {
                    this.listWorkOrderPrePlasterResp.push(this.addDetail(item));
                });

                this.listWorkOrderInspections = [];
                const listInspections = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.EQUIPMENTELETRIC_INSPECTION)];
                listInspections.forEach(item => {
                    this.listWorkOrderInspections.push(this.addDetail(item));
                });
            },

            async loadPlaster() {
                this.listWorkOrderFinalWalkthrough = [];
                const listFinalWalkthrough = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.PLASTE_FINALWALKTHROUGHT)];
                listFinalWalkthrough.forEach(item => {
                    this.listWorkOrderFinalWalkthrough.push(this.addDetail(item));
                });

                this.listWorkOrderVKBowlDeliveryAndInstall = [];
                const listVKBowlDeliveryAndInstall = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.PLASTE_VKBOWLDELIVERY)];
                listVKBowlDeliveryAndInstall.forEach(item => {
                    this.listWorkOrderVKBowlDeliveryAndInstall.push(this.addDetail(item));
                });

                this.listWorkOrderPrep = [];
                const listPrep = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.PLASTE_PREP)];
                listPrep.forEach(item => {
                    this.listWorkOrderPrep.push(this.addDetail(item));
                });

                this.listWorkOrderPlaster = [];
                const listPlaster = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.PLASTE_PLASTER)];
                listPlaster.forEach(item => {
                    this.listWorkOrderPlaster.push(this.addDetail(item));
                });

                this.listWorkOrderOpenItems = [];
                const listOpenItems = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.PLASTE_OPENITEMS)];
                listOpenItems.forEach(item => {
                    this.listWorkOrderOpenItems.push(this.addDetail(item));
                });
            },

            async loadFence() {
                this.listWorkOrderSendPOAndSchedule = [];
                const listSendPOAndSchedule = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.FENCE_SENDPOANDSCHEDULE)];
                listSendPOAndSchedule.forEach(item => {
                    this.listWorkOrderSendPOAndSchedule.push(this.addDetail(item));
                });

                this.listWorkOrderBarrierAndBondInspection = [];
                const listBarrierAndBondInspection = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.FENCE_BARRIERANDBONDINSPECTION)];
                listBarrierAndBondInspection.forEach(item => {
                    this.listWorkOrderBarrierAndBondInspection.push(this.addDetail(item));
                });

                this.listWorkOrderFinalInspection = [];
                const listFinalInspection = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.FENCE_FINALINSPECTION)];
                listFinalInspection.forEach(item => {
                    this.listWorkOrderFinalInspection.push(this.addDetail(item));
                });
            },

            async loadBBQ() {
                this.listWorkOrderBBQUndergroundInspection = [];
                const listBBQUndergroundInspection = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.BBQ_UNDERGROUNDINSPECTION)];
                listBBQUndergroundInspection.forEach(item => {
                    this.listWorkOrderBBQUndergroundInspection.push(this.addDetail(item));
                });

                this.listWorkOrderBBQFrameInstallation = [];
                const listBBQFrameInstallation = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.BBQ_FRAMEINSTALLATION)];
                listBBQFrameInstallation.forEach(item => {
                    this.listWorkOrderBBQFrameInstallation.push(this.addDetail(item));
                });

                this.listWorkOrderBBQFrameAndTieDownInspection = [];
                const listBBQFrameAndTieDownInspection = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.BBQ_FRAMEANDTIEDOWNINSPECTION)];
                listBBQFrameAndTieDownInspection.forEach(item => {
                    this.listWorkOrderBBQFrameAndTieDownInspection.push(this.addDetail(item));
                });

                this.listWorkOrderBBQInstallRoughElectric = [];
                const listBBQInstallRoughElectric = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.BBQ_INSTALLROUGHELECTRIC)];
                listBBQInstallRoughElectric.forEach(item => {
                    this.listWorkOrderBBQInstallRoughElectric.push(this.addDetail(item));
                });

                this.listWorkOrderBBQRoughElectricInspection = [];
                const listBBQRoughElectricInspection = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.BBQ_ROUGHELECTRICINSPECTION)];
                listBBQRoughElectricInspection.forEach(item => {
                    this.listWorkOrderBBQRoughElectricInspection.push(this.addDetail(item));
                });

                this.listWorkOrderBBQDryWallInstallation = [];
                const listBBQDryWallInstallation = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.BBQ_DRYWALLINSTALLATION)];
                listBBQDryWallInstallation.forEach(item => {
                    this.listWorkOrderBBQDryWallInstallation.push(this.addDetail(item));
                });

                this.listWorkOrderBBQDryWallAndTieDownInspection = [];
                const listBBQDryWallAndTieDownInspection = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.BBQ_DRYWALLANDTIEDOWNINSPECTION)];
                listBBQDryWallAndTieDownInspection.forEach(item => {
                    this.listWorkOrderBBQDryWallAndTieDownInspection.push(this.addDetail(item));
                });

                this.listWorkOrderBBQCladdingAndCounterTopInstallation = [];
                const listBBQCladdingAndCounterTopInstallation = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.BBQ_CLADDINGANDCOUNTERTOPINSTALLATION)];
                listBBQCladdingAndCounterTopInstallation.forEach(item => {
                    this.listWorkOrderBBQCladdingAndCounterTopInstallation.push(this.addDetail(item));
                });

                this.listWorkOrderBBQInstallAppliances = [];
                const listBBQInstallAppliances = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.BBQ_INSTALLAPPLIANCES)];
                listBBQInstallAppliances.forEach(item => {
                    this.listWorkOrderBBQInstallAppliances.push(this.addDetail(item));
                });

                this.listWorkOrderBBQFinalElectricInstallation = [];
                const listBBQFinalElectricInstallation = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.BBQ_FINALELECTRICINSTALLATION)];
                listBBQFinalElectricInstallation.forEach(item => {
                    this.listWorkOrderBBQFinalElectricInstallation.push(this.addDetail(item));
                });

                this.listWorkOrderBBQFinalElectricFinalGasFinalPlumbingInspection = [];
                const listBBQFinalElectricFinalGasFinalPlumbingInspection = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.BBQ_FINALELECTRICFINALGASFINALPLUMBINGINSPECTION)];
                listBBQFinalElectricFinalGasFinalPlumbingInspection.forEach(item => {
                    this.listWorkOrderBBQFinalElectricFinalGasFinalPlumbingInspection.push(this.addDetail(item));
                });

                this.listWorkOrderBBQFinalInspection = [];
                const listBBQFinalInspection = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.BBQ_FINALINSPECTION)];
                listBBQFinalInspection.forEach(item => {
                    this.listWorkOrderBBQFinalInspection.push(this.addDetail(item));
                });

            },

            async loadPergola() {
                this.listWorkOrderPergolaFooterFrame = [];
                const listPergolaFooterFrame = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.PERGOLA_FOOTERFRAME)];
                listPergolaFooterFrame.forEach(item => {
                    this.listWorkOrderPergolaFooterFrame.push(this.addDetail(item));
                });

                this.listWorkOrderPergolaInspectionFooterBond = [];
                const listPergolaInspectionFooterBond = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.PERGOLA_INSPECTIONSFOOTERBONDFOOTERFORMSFOOTERFOUNDATION)];
                listPergolaInspectionFooterBond.forEach(item => {
                    this.listWorkOrderPergolaInspectionFooterBond.push(this.addDetail(item));
                });

                this.listWorkOrderPergolaFooterPoured = [];
                const listPergolaFooterPoured = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.PERGOLA_FOOTERSPOURED)];
                listPergolaFooterPoured.forEach(item => {
                    this.listWorkOrderPergolaFooterPoured.push(this.addDetail(item));
                });

                this.listWorkOrderPergolaFooterFinalInspection = [];
                const listPergolaFooterFinalInspection = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.PERGOLA_FOOTERFINALINSPECTION)];
                listPergolaFooterFinalInspection.forEach(item => {
                    this.listWorkOrderPergolaFooterFinalInspection.push(this.addDetail(item));
                });

                this.listWorkOrderPergolaColumnInstallation = [];
                const listPergolaColumnInstallation = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.PERGOLA_COLUMNINSTALLATION)];
                listPergolaColumnInstallation.forEach(item => {
                    this.listWorkOrderPergolaColumnInstallation.push(this.addDetail(item));
                });

                this.listWorkOrderPergolaElectricInstallation = [];
                const listPergolaElectricInstallation = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.PERGOLA_ELECTRICINSTALLATION)];
                listPergolaElectricInstallation.forEach(item => {
                    this.listWorkOrderPergolaElectricInstallation.push(this.addDetail(item));
                });

                this.listWorkOrderPergolaFramingColumn = [];
                const listFramingColumn = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.PERGOLA_FRAMINGCOLUMNCOLUMNBONDFINALELECTRICINSPECTION)]; 
                listFramingColumn.forEach(item => {
                    this.listWorkOrderPergolaFramingColumn.push(this.addDetail(item));
                });

                this.listWorkOrderPergolaFinishInstallation = [];
                const listFinishInstallation = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.PERGOLA_FINISHINSTALLATION)];
                listFinishInstallation.forEach(item => {
                    this.listWorkOrderPergolaFinishInstallation.push(this.addDetail(item));
                });

                this.listWorkOrderPergolaFinalInspection = [];
                const listFinalInspection = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.stage == this.CONSTRUCTION_STAGE.PERGOLA_FINALINSPECTION)];
                listFinalInspection.forEach(item => {
                    this.listWorkOrderPergolaFinalInspection.push(this.addDetail(item));
                });

            },

            addDetail(item) {
                return {
                    name: item.responsibleName,
                    customerName: item.customerName,
                    description: item.scopeOfWork
                }
            },
        },

        async created() {
            this.showLoading();
            await this.getRegisters();
            this.hideLoading();
        },
    })
</script>

<style scoped>
    label {
        font-size: 14px !important;
        color: #5e5e5e;
    }
</style>